export function getFbMatchMeta(match, persona) {
  const isCorrected = Boolean(
    persona?.redes_sociales?.facebook ||
    match?.fb_perfil_override ||
    match?.feedback_status === 'correcto'
  )
  const confianza = String(match?.confianza || '').trim().toUpperCase()
  const isAlta = confianza === 'ALTA' || isCorrected
  const score = isCorrected ? (match?.score || 100) : (match?.score ?? null)

  return {
    isAlta,
    isCorrected,
    score,
    title: isCorrected
      ? 'Perfil verificado / corregido'
      : (isAlta ? 'Matches confianza ALTA (score ≥ 85)' : 'Matches confianza POSIBLE (score 70-84)'),
    shortNote: isCorrected
      ? 'Perfil verificado y asignado a este ciudadano.'
      : (isAlta
        ? 'Coincidencia muy alta. Es muy posible que el perfil corresponda a esta persona, aunque requiere validación visual final.'
        : 'Coincidencia tentativa. El algoritmo no pudo identificar con certeza que el perfil sea de esta persona.'),
    badgeClass: isCorrected
      ? 'border-emerald-300 bg-emerald-500/25 text-emerald-100 font-bold'
      : (isAlta
        ? 'border-emerald-300 bg-emerald-400/10 text-emerald-50'
        : 'border-amber-300 bg-amber-400/10 text-amber-50'),
    accentClass: isCorrected || isAlta ? 'text-emerald-200' : 'text-amber-200',
  }
}

